/*
 * Copyright (c) 2017 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './Layout.css';
import HeaderContainer from '../Header/HeaderContainer';
import {defineMessages, intlShape, injectIntl} from 'react-intl';
import {Helmet} from 'react-helmet';

const messages = defineMessages({
  pageTitle: {
    id: 'App.name',
    description: 'Application name',
    defaultMessage: 'OCLC Service Configuration'
  }
});

const Layout = ({children, intl}) =>

  <div className={styles.container}>
    <Helmet defaultTitle={intl.formatMessage(messages.pageTitle)}
      titleTemplate={'%s | ' + intl.formatMessage(messages.pageTitle)} >
      <title>{intl.formatMessage(messages.pageTitle)}</title>
    </Helmet>
    <HeaderContainer />
    <section>
      {children}
    </section>
  </div>
;

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  intl: intlShape.isRequired
};

export default injectIntl(Layout);



// WEBPACK FOOTER //
// ./src/Layout/Layout.js